import { FullBanner } from './FullBanner';
import { SimpleBanner } from './SimpleBanner';
import { FullBannerProps } from './types/FullBanner.types';
import { SimpleBannerProps } from './types/SimpleBanner.types';

export type BannerColor = 'purple' | 'orange' | 'lightPurple';

export type BannerAction = {
  label: string;
  onClick: () => Promise<void> | void;
};

type BannerProps = FullBannerProps | SimpleBannerProps;

export function Banner(props: BannerProps) {
  if (props.variant === 'full') return <FullBanner {...props} />;

  return <SimpleBanner {...props} />;
}
